<header mat-dialog-title>
    <div class="header-title-content">
        <span *ngIf="zone">Modifica zona: {{ zone.name }} </span>
        <span *ngIf="!zone" class="new-item">Nuova zona</span>
    </div>

    <div class="header-actions" *ngIf="zone">
        <button mat-icon-button [mat-menu-trigger-for]="actionMenu">
          <mat-icon>more_vert</mat-icon>
        </button>
        <mat-menu x-position="before" overlapTrigger="false" #actionMenu="matMenu">
          <button mat-menu-item (click)="deleteZones()">
            <mat-icon>delete</mat-icon>
            Elimina zona
          </button>
        </mat-menu>
    </div>
</header>

<mat-dialog-content>
    <form [formGroup]="zonesForm" novalidate>
        <div class="u-flex-full">
            <mat-form-field class="u-full-width">
                <mat-label>Nome</mat-label>
                <input matInput type="text" formControlName="name" placeholder="Ad esempio: Zona 1" />
                <mat-error *ngIf="zonesForm.get('name').hasError('required')">
                    Campo obbligatorio
                </mat-error>
            </mat-form-field>

            <mat-form-field class="u-full-width">
                <mat-label>Costo Zona</mat-label>
                <input matInput type="number" formControlName="shipping_cost" placeholder="Ad esempio: 5" />
                <mat-error *ngIf="zonesForm.get('shipping_cost').hasError('required')">
                    Campo obbligatorio
                </mat-error>
            </mat-form-field>

        </div>

        <div class="u-flex-full">
          <mat-form-field class="u-full-width">
            <mat-label>Latitudine</mat-label>
            <input matInput type="number" formControlName="latitude" placeholder="Ad esempio: 85" [min]="-90" [max]="90">
            <mat-error *ngIf="zonesForm.get('latitude').hasError('required')">
                Campo obbligatorio
            </mat-error>
            <mat-error *ngIf="zonesForm.get('latitude').hasError('min')">
                Deve essere compresa tra -90 e 90
            </mat-error>
            <mat-error *ngIf="zonesForm.get('latitude').hasError('max')">
                Deve essere compresa tra -90 e 90
            </mat-error>
        </mat-form-field>

        <mat-form-field class="u-full-width">
          <mat-label>Longitudine</mat-label>
          <input matInput type="number" formControlName="longitude" placeholder="Ad esempio: 26" [min]="-90" [max]="90" />
          <mat-error *ngIf="zonesForm.get('longitude').hasError('required')">
              Campo obbligatorio
          </mat-error>
          <mat-error *ngIf="zonesForm.get('longitude').hasError('min')">
              Deve essere compresa tra -90 e 90
          </mat-error>
          <mat-error *ngIf="zonesForm.get('longitude').hasError('max')">
              Deve essere compresa tra -90 e 90
          </mat-error>
      </mat-form-field>
        </div>

        <div class="u-flex-full">
          <mat-form-field class="u-full-width">
            <mat-label>Raggio</mat-label>
            <input matInput type="number" formControlName="radius" placeholder="Ad esempio: 10" />
            <mat-error *ngIf="zonesForm.get('radius').hasError('required')">
                Campo obbligatorio
            </mat-error>
        </mat-form-field>

          <mat-form-field class="u-full-width">
              <mat-label>Punto vendita</mat-label>
              <input type="text" matInput placeholder="Cerca punto vendita"
                     formControlName="tenant_id"
                     [matAutocomplete]="tenantsAutocomplete">
                     <mat-autocomplete #tenantsAutocomplete="matAutocomplete" [displayWith]="displayTenant">
                      <mat-option *ngFor="let tenant of filteredTenants | async" [value]="tenant.id">
                        {{ tenant.name }}
                      </mat-option>
                    </mat-autocomplete>
                    <mat-error *ngIf="zonesForm.get('tenant_id').hasError('required')">
                      Campo obbligatorio
                  </mat-error>
                  </mat-form-field>
        </div>
            </form>
</mat-dialog-content>

<mat-dialog-actions>
    <div class="left-actions">
        <button mat-raised-button (click)="revert()" [disabled]="zonesForm.pristine">
            Reset
        </button>
        <button mat-raised-button color="primary" (click)="save()" [disabled]="zonesForm.pristine || !zonesForm.valid">
            Salva
        </button>
    </div>
    <div class="right-actions">
        <button mat-raised-button (click)="close()">
            Chiudi
        </button>
    </div>
</mat-dialog-actions>
